module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }